var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobiFIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.1783L2.6101 16.7442V3.60492L0 5.07564V15.1783Z",
    fill: "#DA5026"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.36905 9.43921V2.46643L10.4384 7.02041V13.9456L3.36905 9.43921Z",
    fill: "#101018"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60614 18.3091V11.3364L10.4384 7.02039V13.9456L3.60614 18.3091Z",
    fill: "#DA5026"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36207 18.3091L8.68348 20.2063L17.4136 15.1783V5.07562L8.73109 0L4.79263 2.46641L11.3402 6.49874V14.3244L5.36207 18.3091Z",
    fill: "#101018"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobiFIn);
export default __webpack_public_path__ + "static/media/Mobi-FIn.c7f4e43b1fdc53001410e201b71ae02b.svg";
export { ForwardRef as ReactComponent };